const {SHA256} = require("sha2");

export default class Util {

  static hashSHA2 = (val) => {
    return SHA256(val).toString("hex")
  }

}
